import { combineReducers } from '@reduxjs/toolkit';
import { userConfigurationReducer } from '@store/redux/features/userConfiguration';
import { filterReducer } from '@store/redux/features/filter/filterSlice';
import { inventoryReducer } from '@store/redux/features/inventory/inventorySlice';
import { updatesReducer } from '@store/redux/features/updates/updatesSlice';
import { authReducer } from './auth';
import { ticketReducer } from './ticket';
import { notificationReducer } from './notification';
import { organizationReducer } from './organization';
import { searchReducer } from './search/searchSlice';
import { updatesOptimisticReducer } from './updatesOptimistic';
import { knownDataReducer } from './inventory/knownData';
import { mixpanelReducer } from './mixpanel';
import { mobileReducer } from './mobile';

const rootReducer = combineReducers({
  auth: authReducer,
  filter: filterReducer,
  search: searchReducer,
  ticket: ticketReducer,
  notification: notificationReducer,
  userConfiguration: userConfigurationReducer,
  organization: organizationReducer,
  inventory: inventoryReducer,
  updates: updatesReducer,
  updatesOptimistic: updatesOptimisticReducer,
  knownData: knownDataReducer,
  mixpanelStore: mixpanelReducer,
  mobileStore: mobileReducer,
});
type IRootReducer = typeof rootReducer;
type IRootState = ReturnType<IRootReducer>;

export { rootReducer };
export type { IRootReducer, IRootState };
